<template>
  <div v-bem>
    <h2 v-bem:title>{{ title }}</h2>
    <div v-if="hasAboveSlot" v-bem:above>
      <slot name="above" />
    </div>
    <div v-bem:image>
      <img :src="imageUrl" />
    </div>
    <div v-if="hasBelowSlot" v-bem:below>
      <slot name="below" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImageSection',
  props: {
    title: {
      type: String,
      required: true,
    },
    imageUrl: {
      type: String,
      required: true,
    },
  },
  computed: {
    hasAboveSlot() {
      return !!this.$slots.above;
    },
    hasBelowSlot() {
      return !!this.$slots.below;
    },
  },
};
</script>

<style lang="scss" scoped>
@use '~tokens/sass/utils';
@use "sass:map";

.image-section {
  margin-bottom: 2em;

  @at-root #{&}__title {
    margin-bottom: 0;
    font-size: utils.f-rem-calc(16);
    font-weight: 500;
    font-family: map.get(utils.$v-font-families, sans);
    line-height: 1.2em;
  }

  @at-root #{&}__above {
    margin-top: utils.f-rem-calc(5);
  }

  @at-root {
    #{&}__above,
    #{&}__below {
      > :last-child {
        margin-bottom: 0;
      }
    }
  }

  @at-root #{&}__image {
    margin: utils.f-rem-calc(16) 0;
    padding: utils.f-rem-calc(20) utils.f-rem-calc(30);
    background-color: map.get(utils.$v-colors, rw-brown-02);
  }
}
</style>
